/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_Signals_TitleInputs */

const en_directory_builders_signals_title = /** @type {(inputs: Directory_Builders_Signals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile signals`)
};

const zh_directory_builders_signals_title = /** @type {(inputs: Directory_Builders_Signals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资料信号`)
};

/**
* | output |
* | --- |
* | "Profile signals" |
*
* @param {Directory_Builders_Signals_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_signals_title = /** @type {((inputs?: Directory_Builders_Signals_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_Signals_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_signals_title(inputs)
	return zh_directory_builders_signals_title(inputs)
});
export { directory_builders_signals_title as "directory.builders.signals_title" }